import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { SearchHeader } from '@ifca-root/react-component/src/components/Header/SearchHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import {
  CircularProgress,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
  TextField,
} from '@material-ui/core'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import {
  RecordStatus,
  useGetAssignedCompanyQuery,
  useGetHomeSummaryQuery,
} from 'generated/graphql'
import { useFuseSearch } from 'helpers/Hooks/useSearch'
import React, { useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import FloatButton from '@ifca-root/react-component/src/components/Button/FloatButton'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import { useForm, Controller } from 'react-hook-form'
import MoreVert from '@material-ui/icons/MoreVert'

export const BeneficiaryBankCodeListing = () => {
  const getSearch = localStorage?.getItem('searchFilter')
  let history = useHistory()
  const { CompanyID }: any = useParams()
  const [TotalLength, setTotalLength] = useState(0)
  const { filteredList, handleSearch, setOriginalListing } = useFuseSearch()
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)
  const [timer, setTimer] = useState(null)
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false)

  const { anchorEl, menu, handleClick, handleClose } = useMenuOption()

  const { register, errors, handleSubmit, control } = useForm()

  const {
    loading: HomeSummaryLoading,
    called,
    data: {
      loggedInUserProfile,
      getAccountPermission,
      getCompany: curCompany,
      getRolePermission,
    } = {
      loggedInUserProfile: null,
      getAccountPermission: [],
      getCompany: [],
      getRolePermission: [],
    },
  } = useGetHomeSummaryQuery({
    fetchPolicy: 'network-only',
    variables: {
      CompanyID,
    },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)

      if (
        !CompanyID ||
        CompanyID === 'undefined' ||
        CompanyID === 'null' ||
        CompanyID === ''
      ) {
        setErrDialog(true)
        setErrMessage('Please select company before continue.')
        return
      }
    },
  })

  const {
    loading: CompanyAssignedLoading,
    data: { getAssignedCompanyByUser } = { getAssignedCompanyByUser: [] },
  } = useGetAssignedCompanyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  function changeDelay(change) {
    if (timer) {
      clearTimeout(timer)
      setTimer(null)
    }

    setTimer(
      setTimeout(() => {
        setOriginalListing([])
        // loadData({
        //   variables: { CompanyID, skip: 0, take: 30, searchValue: change },
        // })
      }, 1000)
    )
  }

  const bankAccount = [
    {
      GlAccountCode: '123',
      BankAccountID: '123',
      AccountNo: '123',
      BankProfileID: '123',
      BankProfile: {
        Name: 'Maybank',
      },
      RecordStatus: 'ACTIVE',
      CommonStatus: 'ACTIVE',
      Code: 'MBB',
    },
    {
      GlAccountCode: '123',
      BankAccountID: '123',
      AccountNo: '123',
      BankProfileID: '123',
      BankProfile: {
        Name: 'CIMB',
      },
      RecordStatus: 'ACTIVE',
      CommonStatus: 'ACTIVE',
      Code: 'CIBB',
    },
  ]

  const bankAccountLoading = false

  useEffect(() => {
    setTotalLength(bankAccount?.length)
  }, [])

  return (
    <>
      {HomeSummaryLoading && <Loading />}
      {CompanyAssignedLoading && <Loading />}

      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.goBack()
        }}
        smTitle="AccountX"
        title={curCompany[0]?.Name}
        rightCustomIcon={curCompany[0]?.Logo?.fileURL}
        routeSegments={[
          { name: 'Bank ETF' },
          { name: 'Beneficiary Bank Code', current: true },
        ]}
      />
      <div className="search-filter with-dropdown-filter ">
        <SearchHeader
          title="Bank Listing"
          value={`${TotalLength}`}
          search
          // fixed
          onChangeAction={e => {
            changeDelay(e.target.value)
            localStorage.setItem('searchFilter', e?.target?.value)
          }}
          onCloseAction={() => {
            handleSearch('', [])
            localStorage.removeItem('searchFilter')
            setOriginalListing([])
            // loadData({
            //   variables: { CompanyID, skip: 0, take: 30 },
            // })
          }}
          isDefaultValue={!!getSearch}
          defaultValue={!!getSearch ? getSearch : ''}
        />
      </div>
      <ContentWrapper float>
        <List className="core-list">
          {bankAccount === undefined || bankAccount?.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new Bank Account now."
            />
          ) : (
            <InfiniteScroll
              dataLength={bankAccount?.length}
              next={() => {
                const currentLength = bankAccount?.length
                // loadData({
                //   variables: {
                //     CompanyID,
                //     skip: currentLength,
                //     take: 30,
                //     searchValue: getSearch === '' ? undefined : getSearch,
                //   },
                // })
              }}
              hasMore={true}
              style={{ padding: '8px 6px' }}
              loader={
                bankAccountLoading && (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              {bankAccount
                ?.sort((a, b) => {
                  return a?.BankProfile?.Name.localeCompare(
                    b?.BankProfile?.Name
                  )
                })
                ?.map((el, index) => {
                  return (
                    <ListItem
                      key={index}
                      style={{
                        backgroundColor:
                          el.CommonStatus === RecordStatus.Inactive
                            ? '#eaeaea'
                            : null,
                      }}
                    >
                      <ListItemText
                        primary={
                          <>
                            <span className="xsTitle flex-space">
                              {`${el?.BankProfile?.Name} | ${el?.Code}`}
                            </span>
                          </>
                        }
                        secondary={
                          <>
                            <Grid
                              spacing={1}
                              container
                              className="table-content"
                            >
                              <Grid item xs={12}>
                                <span className="desc flex-space">
                                  {`${el.AccountNo} | ${el?.GlAccountCode}`}
                                </span>
                              </Grid>
                            </Grid>
                            <Grid
                              spacing={1}
                              container
                              className="table-content"
                            >
                              {/* <Grid item xs={6}>
                                <span className="desc flex-space">
                                  {`GL Balance : ${
                                    el?.ClosingBalance < 0
                                      ? `(${amtStr(-el?.ClosingBalance)})`
                                      : amtStr(el?.ClosingBalance)
                                  }`}
                                </span>
                              </Grid>

                              <Grid item xs={6} style={{ textAlign: 'right' }}>
                                <span className=" xsTitle c-orange">
                                  <span style={{ fontSize: '12px' }}>
                                    {el?.BankBalance < 0
                                      ? `(${amtStr(-el?.BankBalance)})`
                                      : amtStr(el?.BankBalance)}
                                  </span>
                                </span>
                              </Grid> */}
                            </Grid>
                          </>
                        }
                      />
                      <ListItemSecondaryAction>
                        <ListItemSecondaryAction>
                          <IconButton
                            edge="end"
                            aria-label="more"
                            aria-controls="menu-list"
                            aria-haspopup="true"
                            onClick={e =>
                              handleClick(e, el?.BankAccountID, index, el)
                            }
                          >
                            <MoreVert />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItemSecondaryAction>
                    </ListItem>
                  )
                })}
            </InfiniteScroll>
          )}
        </List>
      </ContentWrapper>
      <Menu
        id="menu-list"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
      >
        <MenuItem
          onClick={() => {
            // history.push({
            //   pathname:
            //     location?.pathname === '/access-security/role'
            //       ? `/access-security/role/detail/${menu.ID}`
            //       : `/general-ledger/access-security/role/detail/${menu.ID}`,
            //   state: menu?.obj,
            // })
          }}
        >
          View
        </MenuItem>
        <MenuItem
          onClick={
            () => {}
            // history.push({
            //   path: `/${BeneficiaryBankCodeID}`,
            //   state: menu?.obj,
            // })
          }
        >
          Edit
        </MenuItem>
      </Menu>
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
      <FloatButton onClick={() => setIsAddDialogOpen(true)} />
      <CommonDialog
        fullWidth={true}
        open={isAddDialogOpen}
        onClose={() => setIsAddDialogOpen(false)}
        sections={{
          header: {
            title: 'Bank Code',
          },
          body: () => (
            <>
              <Controller
                as={TextField}
                id="standard-basic"
                name="Code"
                label="Code"
                required
                autoComplete="off"
                control={control}
                fullWidth
                margin="dense"
                helperText={errors?.Code?.message}
                error={errors?.Code ? true : false}
                ref={register}
              />
              <Controller
                as={TextField}
                id="standard-basic"
                name="Name"
                label="Name"
                required
                autoComplete="off"
                control={control}
                fullWidth
                margin="dense"
                helperText={errors?.Name?.message}
                error={errors?.Name ? true : false}
                ref={register}
              />
              <Controller
                as={TextField}
                id="standard-basic"
                name="Batch Number"
                label="BatchNumber"
                required
                autoComplete="off"
                control={control}
                fullWidth
                margin="dense"
                helperText={errors?.BatchNumber?.message}
                error={errors?.BatchNumber ? true : false}
                ref={register}
              />
            </>
          ),
          footer: {
            actions: [
              {
                displayText: 'Close',
                props: {
                  onClick: () => setIsAddDialogOpen(false),
                  variant: 'contained',
                  color: 'secondary',
                },
              },
              {
                displayText: 'Save',
                props: {
                  onClick: () => {},
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />
    </>
  )
}

export default BeneficiaryBankCodeListing
